module.exports = __webpack_public_path__ + "static/media/client-genasys.17738402.png";